export default __webpack_public_path__ + "static/media/leftcorner.b937db67.png";